import { useMemo } from 'react';

// Static agent data extracted from squad agent definitions
const AGENTS_DATA = [
  { name: 'Eva', id: 'orquestrador', title: 'Orquestradora de Agentes', icon: '\u2728', squad: 'Orquestracao' },
  { name: 'Cris', id: 'finalizador', title: 'Revisora & Finalizadora', icon: '\u2705', squad: 'Orquestracao' },
  { name: 'Brunson', id: 'estrategista-funil', title: 'Estrategista de Funil & Conteudo', icon: '\uD83C\uDFAF', squad: 'Estrategia' },
  { name: 'Patel', id: 'analista-metricas', title: 'Analista de Metricas & Performance', icon: '\uD83D\uDCCA', squad: 'Estrategia' },
  { name: 'Quinn', id: 'account-manager', title: 'Account Manager', icon: '\uD83E\uDD1D', squad: 'Estrategia' },
  { name: 'Ogilvy', id: 'copywriter', title: 'Copywriter Estrategico', icon: '\u270D\uFE0F', squad: 'Criacao' },
  { name: 'Hormozi', id: 'roteirista', title: 'Roteirista de Videos', icon: '\uD83C\uDFAC', squad: 'Criacao' },
  { name: 'GaryVee', id: 'ganchos-virais', title: 'Especialista em Ganchos Virais', icon: '\uD83C\uDFA3', squad: 'Criacao' },
  { name: 'Draper', id: 'diretor-criativo', title: 'Diretor Criativo & Brand Voice', icon: '\uD83C\uDFA8', squad: 'Criacao' },
  { name: 'Sasha', id: 'social-media-manager', title: 'Social Media Manager', icon: '\uD83D\uDCF1', squad: 'Social & Comunidade' },
  { name: 'Maya', id: 'community-manager', title: 'Community Manager', icon: '\uD83D\uDCAC', squad: 'Social & Comunidade' },
  { name: 'Foxwell', id: 'media-buyer', title: 'Media Buyer & Performance', icon: '\uD83D\uDCB0', squad: 'Trafego Pago' },
  { name: 'Neumeier', id: 'creative-briefer', title: 'Creative Briefer', icon: '\uD83D\uDCCB', squad: 'Producao' },
];

const SQUAD_ORDER = ['Orquestracao', 'Estrategia', 'Criacao', 'Social & Comunidade', 'Trafego Pago', 'Producao'];

export function useAgents() {
  const agents = useMemo(() => AGENTS_DATA, []);

  const agentsBySquad = useMemo(() => {
    const grouped = {};
    for (const squad of SQUAD_ORDER) {
      grouped[squad] = agents.filter(a => a.squad === squad);
    }
    return grouped;
  }, [agents]);

  const getAgent = (id) => agents.find(a => a.id === id) || null;

  return { agents, agentsBySquad, getAgent, squadOrder: SQUAD_ORDER };
}
